import { formatDeviceId } from '@viewer/protocol';
import { useState, type FormEvent } from 'react';
import type { OutgoingRequest } from '../../lib/session/controller';
import styles from './OutgoingRequestDialog.module.css';

interface Props {
  request: OutgoingRequest;
  onSubmitPassword(password: string): void;
  onCancel(): void;
}

export function OutgoingRequestDialog({ request, onSubmitPassword, onCancel }: Props) {
  const [password, setPassword] = useState('');
  const canUsePassword = request.passwordEnabled && request.attemptsLeft !== 0;

  function submit(e: FormEvent) {
    e.preventDefault();
    if (!password || request.checkingPassword) return;
    onSubmitPassword(password);
    setPassword('');
  }

  return (
    <div className={styles.backdrop} role="dialog" aria-modal="true">
      <div className={styles.dialog}>
        <div className={styles.spinner} aria-hidden="true" />
        {request.autoAcceptAt ? (
          <>
            <h2 className={styles.title}>Conectando</h2>
            <p className={styles.text}>
              Acesso sem supervisão a <strong>{formatDeviceId(request.targetId)}</strong>. O computador remoto está
              sendo avisado e a conexão começa em alguns segundos, a menos que alguém recuse.
            </p>
          </>
        ) : (
          <>
            <h2 className={styles.title}>Aguardando autorização</h2>
            <p className={styles.text}>
              Pedido enviado para <strong>{formatDeviceId(request.targetId)}</strong>. O computador remoto precisa
              aceitar a conexão.
            </p>
          </>
        )}

        {canUsePassword && (
          <form className={styles.passwordForm} onSubmit={submit}>
            <label className={styles.passwordLabel} htmlFor="access-password">
              Ou entre com a senha de acesso
            </label>
            <div className={styles.passwordRow}>
              <input
                id="access-password"
                className={styles.passwordInput}
                type="password"
                autoComplete="off"
                autoFocus
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={request.checkingPassword}
              />
              <button type="submit" className={styles.enter} disabled={!password || request.checkingPassword}>
                {request.checkingPassword ? 'Verificando...' : 'Entrar'}
              </button>
            </div>
            {request.attemptsLeft !== null && (
              <p className={styles.passwordError}>
                Senha incorreta. {request.attemptsLeft === 1 ? 'Resta 1 tentativa.' : `Restam ${request.attemptsLeft} tentativas.`}
              </p>
            )}
          </form>
        )}
        {request.passwordEnabled && request.attemptsLeft === 0 && (
          <p className={styles.passwordError}>Tentativas esgotadas. Aguarde a autorização do computador remoto.</p>
        )}

        <button className={styles.cancel} onClick={onCancel}>
          Cancelar
        </button>
      </div>
    </div>
  );
}
